import React from "react";
import PageBanner from "../Components/PageBanner";
import bannerBg from "../assets/img/gold-coin-war.png";
import { Link } from "react-router-dom";
import aboutImg from "../assets/img/home3/about.jpg";
import img1 from "../assets/img/home3/about-element.png";
// import icon1 from "../../assets/img/icons/p1.png";
// import icon2 from "../../assets/img/icons/p2.png";
// import icon3 from "../../assets/img/icons/p3.png";
import icon1 from "../assets/img/icons/p1.png";
import icon2 from "../assets/img/icons/p2.png";
import icon3 from "../assets/img/icons/p3.png";

const Warehouse = () => {
  const data = [
    { id: "Big Shed ", name: "1,41,763 Sq. Ft. ", email: "32,300 MT " },
    { id: "Small Shed ", name: "15,128 Sq. Ft. ", email: "2,000 MT " },
    { id: "Total ", name: "1,56,891 Sq. Ft. ", email: "34,300 MT " },
  ];
  return (
    <>
      <PageBanner
        title="GOLD COIN WAREHOUSING     "
        bannerBg={bannerBg}
        currentPage="GOLD COIN WAREHOUSING    "
      />
      <section className="about-our-agency section-padding fix pb-5">
        <div className="container">
          <div className="row align-items-center">
            {/* <div className="col-xl-6 col-lg-6 pe-xl-5 ps-xl-5 col-12">
                            <div className="about-company-img">
                                <img src={aboutImg} alt="" />
                                <img src={img1} className="about-element" alt="" />
                            </div>
                        </div> */}
            <div className="col-xl-12 col-lg-12 col-12 mt-5 mt-lg-0">
              <div className="section-title-3">
                <h2>Taraghadi Warehouse </h2>
                  <div className="single-info">
                    <a href="https://maps.app.goo.gl/8UraGvxTB6oEz9bk7">
                    <div className="icon">
                      <i className="flaticon-pin" />
                    </div>
                    </a>
                  </div>

                <h6>(Popularly known as "GOLD COIN") </h6>
                <p>
                  Located strategically along the main highway connecting Rajkot
                  and Jamnagar, Taraghadi Warehouse spans a vast 53.33-acre
                  industrial land. It currently operates as a fully functional
                  storage facility, catering to major corporations such as ITC,
                  NBHC, NCMSL, ORIGO Commodities, Louis Dreyfus, Olam
                  International, and Cargill. These companies utilize the
                  facility for bulk storage and stuffing of commodities such as
                  wheat, castor, and cotton.{" "}
                </p>
                <p>
                  Of the total 53.33 acres, 12 acres are occupied by two large
                  warehouse sheds, while the remaining land remains vacant and
                  available for future development.{" "}
                </p>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-xl-12 col-lg-12 col-12 mt-5 mt ">
              <div className="checked-features-list style-2">
                <h6>Key Features: </h6>
                <ul>
                  <li>
                    Industrial N.A. (Non-Agricultural) Land – Officially
                    converted for industrial use.{" "}
                  </li>
                  <li>
                    Satellite View Available – to view the warehouse location on
                    Google Maps.{" "}
                    <a
                      href="https://www.google.co.in/maps/place/Gold+Coin+Warehouse/@22.383928,70.687859,1397m/data=!3m1!1e3!4m6!3m5!1s0x3959c58a1c794491:0x657d19eef9b2334f!8m2!3d22.3820625!4d70.6861875!16s%2Fg%2F11h0nshdc?hl=en&entry=ttu&g_ep=EgoyMDI1MDIxMi4wIKXMDSoJLDEwMjExNDU1SAFQAw%3D%3D"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Click here
                    </a>{" "}
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="pricing-wrapper section-padding pricing-bg pt-3">
        <div className="container">
          <div className="row">
            <h2>Warehouse Sheds </h2>
            <div className="col-lg-6 col-md-6 col-12">
              <div
                className="single-pricing-plan"
                style={{
                  textAlign: "left",
                }}
              >
                <div className="package-head">
                  {/* <div className="icon">
                  <img src={icon1} alt="" />
                </div> */}
                  <div className="package-title">
                    <h6>1. Main Godown Shed </h6>
                    {/* <h2>$49.00</h2> */}
                  </div>
                </div>
                <div className="package-features">
                  <div className="checked-features-list style-2">
                    <ul>
                      <li>
                        Structure: A single, open-layout prefabricated shed with
                        no partitions.
                      </li>
                      <li>
                        Flooring: Fully raised cement platform, including lab
                        and storage areas.
                      </li>
                      <li>
                        Walls:
                        <ul>
                          <li>
                            Lower 5 feet – Constructed with cement walls.{" "}
                          </li>
                          <li>Upper section – Made of galvanized sheets. </li>
                        </ul>
                      </li>
                      <li>
                        Roofing: A combination of galvanized and cement/asbestos
                        sheets.
                      </li>
                      <li>
                        Storage Allocation: This shed is referenced as portions
                        No. 11 to No. 17 in capacity calculations.
                      </li>
                    </ul>
                  </div>
                </div>
                {/* <div className="package-btn">
                <Link to="/contact">Choose Plan</Link>
              </div> */}
              </div>
            </div>
            <div className="col-lg-6 col-md-6 col-12">
              <div
                className="single-pricing-plan"
                style={{
                  textAlign: "left",
                }}
              >
                <div className="package-head">
                  {/* <div className="icon">
                  <img src={icon3} alt="" />
                </div> */}
                  <div className="package-title">
                    <h6>2.Productivity :</h6>
                    {/* <h2>$89.00</h2> */}
                  </div>
                </div>
                <div className="package-features">
                  <div className="checked-features-list style-2">
                    <ul>
                      <li>
                        Structure: A single, open-layout prefabricated shed with
                        no partitions.
                      </li>
                      <li>
                        Flooring: Fully raised cement platform, including lab
                        and storage areas.
                      </li>
                      <li>
                        Walls:
                        <ul>
                          <li>
                            Lower 5 feet – Constructed with cement walls.{" "}
                          </li>
                          <li>Upper section – Made of galvanized sheets. </li>
                        </ul>
                      </li>
                      <li>
                        Roofing: A combination of galvanized and cement/asbestos
                        sheets.
                      </li>
                      <li>
                        Storage Allocation: This shed is referenced as portions
                        No. 11 to No. 17 in capacity calculations.
                      </li>
                    </ul>
                  </div>
                </div>
                {/* <div className="package-btn">
                <Link to="/contact">Choose Plan</Link>
              </div> */}
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="about-our-agency   py-4 ix">
        <div className="row">
          <div className="col-xl-6 col-lg-8 mb-4 offset-xl-3 offset-lg-2 col-12 text-lg-center">
            <div className="section-title">
              <h2>Warehouse Specifications </h2>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="row align-items-center">
            <div className="p-4">
              <div className="overflow-x-auto">
                <table className="min-w-full bg-white border border-gray-200 shadow-md rounded-lg">
                  <thead className="bg-gray-100 border-b newtable">
                    <tr>
                      <th className="px-4 py-2 text-left">Shed Type </th>
                      <th className="px-4 py-2 text-left">Size (Sq. Ft.) </th>
                      <th className="px-4 py-2 text-left">
                        Storage Capacity (MT) (Approx.){" "}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {data.map((item) => (
                      <tr key={item.id} className="border-b hover:bg-gray-50 ">
                        <td className="px-4 py-2">{item.id}</td>
                        <td className="px-4 py-2">{item.name}</td>
                        <td className="px-4 py-2  ">{item.email}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Warehouse;
